import { parseFirstName } from '@gettactic/helpers/src/user/user-utils';
import { getGreeting } from '@gettactic/helpers/src/date-time/getGreeting';

interface TeamAttendanceHeaderProps {
  totalUsers: number;
  authenticatedUserName?: string;
}

export const TeamAttendanceHeader = ({ authenticatedUserName = '', totalUsers }: TeamAttendanceHeaderProps) => {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className='v2-header-1'>
        {getGreeting()},{' '}
        {parseFirstName(authenticatedUserName || '')}
      </div>
      {typeof totalUsers === 'number' && (
        <div>
          {totalUsers}{' '}
          {totalUsers === 1 ? 'person' : 'people'}{' '}
          expected to be in the office this week
        </div>
      )}
    </div>
  );
}; 